"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssessmentForFeedback = void 0;
const core_1 = require("@zodios/core");
const zod_1 = __importDefault(require("zod"));
exports.getAssessmentForFeedback = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/assessment/:entityType/:entityId/feedback",
    alias: "getAssessmentForFeedback",
    parameters: [
        {
            type: "Path",
            name: "entityType",
            schema: zod_1.default.enum(["message", "assessmentReview"]),
        },
        {
            type: "Path",
            name: "entityId",
            schema: zod_1.default.string(),
        },
    ],
    response: zod_1.default.object({
        score: zod_1.default.number(),
        pronunciation: zod_1.default
            .object({
            score: zod_1.default.number(),
            words: zod_1.default.array(zod_1.default.object({
                word: zod_1.default.string(),
                score: zod_1.default.number(),
            })),
        })
            .nullable(),
        native: zod_1.default
            .object({
            score: zod_1.default.number(),
            sentence: zod_1.default.array(zod_1.default.object({
                word: zod_1.default.string(),
                kind: zod_1.default.enum(["added", "removed", "notChanged"]),
            })),
        })
            .nullable(),
        grammar: zod_1.default
            .object({
            score: zod_1.default.number(),
            sentence: zod_1.default.array(zod_1.default.object({
                word: zod_1.default.string(),
                kind: zod_1.default.enum(["added", "removed", "notChanged"]),
            })),
        })
            .nullable(),
    }),
});
//# sourceMappingURL=getAssessmentForFeedback.js.map